import { AiOutlineSchedule } from 'react-icons/ai';
import {
  FaBuffer,
  FaFileUpload,
  FaListAlt,
  FaPlus,
} from 'react-icons/fa';
import { IoPersonAddSharp, IoTrophySharp } from 'react-icons/io5';
import { RiPinDistanceFill } from 'react-icons/ri';
import colors from '../../constants/color';

export const scheduleProps = [
  {
    labe: 'Regras de reserva',
    icon: <RiPinDistanceFill style={{ color: colors.grey1 }} />,
    path: '/buffer',
  },
  {
    labe: 'Agenda de corretores',
    icon: <AiOutlineSchedule style={{ color: colors.grey1 }} />,
    path: '/reservas-de-posicoes',
  },
];
export const PolepostionProps = [
  {
    labe: 'Polepositions',
    icon: <FaListAlt style={{ color: colors.grey1 }} />,
    path: '/polipositions',
  },
  {
    labe: 'Criar poleposition',
    icon: <FaPlus style={{ color: colors.grey1 }} />,
    path: '/newPoliposition',
  },
  {
    labe: 'Importar arquivo',
    icon: <FaFileUpload style={{ color: colors.grey1 }} />,
    path: '/import/poliposition',
  },
  {
    labe: 'Adicionar critérios',
    icon: <FaBuffer style={{ color: colors.grey1 }} />,
    path: '/novo-criterio',
  },
  {
    labe: 'Critérios',
    icon: <FaBuffer style={{ color: colors.grey1 }} />,
    path: '/criterios',
  },
  {
    labe: 'Ranking',
    icon: <IoTrophySharp style={{ color: colors.grey1 }} />,
    path: '/ranking',
  },
];
export const ScheduleReservation = [
  {
    labe: 'Reservas',
    icon: <FaListAlt style={{ color: colors.grey1 }} />,
    path: '/scheduleReservation',
  },
  {
    labe: 'Criar horário de reserva',
    icon: <FaPlus style={{ color: colors.grey1 }} />,
    path: '/newScheduleReservation',
  },
];
export const userManagement = [
  {
    labe: 'Adicionar usuário',
    icon: <IoPersonAddSharp style={{ color: colors.grey1 }} />,
    path: '/usuarios',
  },
];
